import { Dialog, DialogTitle, Divider, Grid, Paper, styled, Table, TableBody, TableCell, tableCellClasses,
  TableContainer, TableHead, TablePagination, TableRow, Typography,ToggleButton } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import AcountsServices from "../../../Services/MasterBilling/AcountsServices";
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import Home from "../../home/Home";
import Snacbar from "../../Snacbar";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useNavigate } from "react-router";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#008080",
    color: theme.palette.common.white,    
    padding: theme.spacing(0.5),
    fontFamily: 'Times New Roman',
    fontWeight: 'bold',
      textAlign: "center",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,    
    fontFamily: 'Times New Roman',
    textAlign: 'center'
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}));
const ItemPap = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  // border: " 1px solid black",
  // backgroundColor: "#C8EDE7",
  height: "100%",
}));
const ItemPap1 = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  backgroundColor: "white",
  height: "100%",
}));

function Account() {
  const mystyle = {
    border: " 1px solid black",
    width: "10rem",
    fontFamily: 'Times New Roman',
  };
  const mystyle1 = {
    fontWeight: "bolder",
    color: "red",
    fontFamily: 'Times New Roman',
  };
  const [open, setOpen] = useState(false);
  const [severity, setSeverity] = useState('');
  const [message, setMessage] = useState('');

  const [AccountLedgerType, setAccountLedgerType] = useState([]);
  const [AccountHead, setAccountHead] = useState([]);

  const [accounts, setaccounts] = useState({
    accountledgerType: '',
    accountName: '',
    Old_accountName: '',
  });
  const [error, setError] = useState(false);
  const [AcSaveDsa, setAcSaveDsa] = useState(false);
  const [AcUpdateDsa, setAcUpdateDsa] = useState(true);
  const [AcDeleteDsa, setAcDeleteDsa] = useState(true);

  const [AcSave, setAcSave] = useState(false);
  const [AcUpdate, setAcUpdate] = useState(false);
  const [AcDelete, setAcDelete] = useState(false);
  const [Filtereddetails, setFiltereddetails] = useState([]);

  const acc_ledgehandlechange = (e) => {
    setaccounts({ ...accounts, accountledgerType: e.target.value });
  };
  const acc_namehandlechange = (e) => {
    setaccounts({ ...accounts, accountName: e.target.value });
  };
  //icon
  const deleteicon = () => {
    return <DeleteOutlineRoundedIcon style={{color:'red'}}/>
  }
  //getDrp
  const getDrpData = async () => {
    AcountsServices.getAccountLedgerType().then((res) => {
      setAccountLedgerType(res.data);
    })
  }
  const getData = async () => {
    AcountsServices.getAccountHead().then((res) => {
      setAccountHead(res.data);
      setFiltereddetails(res.data)
    })
  }

  useEffect(() => {
    const getData = async () => {
      AcountsServices.getAccountHead().then((res) => {
        setAccountHead(res.data);
        setFiltereddetails(res.data)
      })
    }
    getDrpData();
    getData();
  }, []);

  //tableClick

  const editAccountHeadDCetails = (item) => {
    setError(false);
    setAcSaveDsa(true); setAcUpdateDsa(false); setAcDeleteDsa(false);
    setAcSave(false); setAcUpdate(false); setAcDelete(false);
    setaccounts({ ...accounts, accountledgerType: item.accountHeadType, accountName: item.accountHeadName, Old_accountName: item.accountHeadName });
  }

  //clickEvent
  const validate = () => {
    if (accounts.accountledgerType !== '') {
      return true;
    } else {
      setOpen(true); setSeverity('warning'); setMessage('Pleas select a AccountLedgerType');
      setError(true);
      document.getElementById('AcLedgTyp').focus();
    }
    return false;
  }

  const AccountSave = () => {
    if (validate() === true) {
      setAcSaveDsa(true); setAcSave(true);
      let details = { accountHeadName: accounts.accountName, accountHeadType: accounts.accountledgerType }
      AcountsServices.insertAccountHead(details).then((res) => {
        const message = res.data.message;
        if (message.toString() === 'SUCCESS') {
          setOpen(true); setSeverity('success'); setMessage(message);
        } else {
          setOpen(true); setSeverity('error'); setMessage('Insertion Failed');
        } refresh(); getData();
      }).catch(error => {
        setOpen(true); setSeverity('error'); setMessage(error.message); refresh(); getData();
      })
    }
  }
  const AccountUpdate = () => {
    if (validate() === true) {
      setAcSaveDsa(true); setAcSave(true);
      let details = { accountHeadName: accounts.accountName, accountHeadType: accounts.accountledgerType, oldAccHeadName: accounts.Old_accountName }
      AcountsServices.updateAccountHead(details).then((res) => {
        const message = res.data.message;
        if (message.toString() === 'SUCCESS') {
          setOpen(true); setSeverity('success'); setMessage(message);
        } else {
          setOpen(true); setSeverity('error'); setMessage('Updation Failed');
        } refresh(); getData();
      }).catch(error => {
        setOpen(true); setSeverity('error'); setMessage(error.message); refresh(); getData();
      })
    }
  }
  const AccountDelete = () => {
    if (validate() === true) {
      setAcSaveDsa(true); setAcSave(true);
      setalertopen(true)
    }
  }

  const refresh = () => {
    setPage(0)
    setError(false);
    setAcSaveDsa(false); setAcUpdateDsa(true); setAcDeleteDsa(true);
    setAcSave(false); setAcUpdate(false); setAcDelete(false);
    setaccounts({ ...accounts, accountledgerType: '', accountName: '', Old_accountName: '' });
  }

  //handleClose/open
  const handleClose = () => {
    setOpen(false);
  }
  //table search
  const AccounthdNmSrch = () => {
    return <input className="searchBoxes" onChange={(e) => { AccounthdNmOnchange(e.target.value) }} placeholder="Search" />
  }
  const AccounthdNmOnchange = (searchedVal) => {
    const FilterValues = AccountHead.filter((trns) => {
      return trns.accountHeadName.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (FilterValues.length < 1) {
      setFiltereddetails(AccountHead)
    } else {
      setFiltereddetails(FilterValues)
    }
  }
  //paginationCodes

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  }
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }
  //alertbox
  const [alertopen, setalertopen] = useState(false);

  const alertonClickOpen = (item) => {
    setaccounts({ ...accounts, Old_accountName: item.accountHeadName })
    setalertopen(true)
  }

  const alertNoOnClick = () => {
    refresh();
    setalertopen(false)
  }

  const alertYesOnClick = () => {
    AcountsServices.deleteAccountHead(accounts.Old_accountName).then((res) => {
      const message = res.data.message;
      if (message.toString() === 'SUCCESS') {
        setOpen(true); setSeverity('success'); setMessage(message);
      } else {
        setOpen(true); setSeverity('error'); setMessage('Failed To Delete');
      } refresh(); getData();
    }).catch(error => {
      setOpen(true); setSeverity('error'); setMessage(error.message); refresh(); getData();
    })
    setalertopen(false)
  }

  const navigate = useNavigate();
  const BackBotton =()=>{
    navigate('/Unitofmeasurement');
  }
  const ForwordBotton =()=>{
    navigate('/Billpaidto');
  }
  return (
    <div>
       <Dialog open={alertopen}>
        <DialogTitle>
          <center><h6 style={{ fontFamily: 'Times New Roman'}}>ARE YOU SURE,</h6></center>
          <h6 style={{ fontFamily: 'Times New Roman'}}>YOU WANT TO DELETE ?</h6>
          <Divider color="#FDA228" sx={{ height: 2 }} />
        </DialogTitle>
        <div className="form-inline p-1">
          <center><Button variant="danger" className="p-1 mb-2 mr-1" style={{ width: '50px',fontFamily: 'Times New Roman' }} onClick={alertYesOnClick}>Yes</Button>&nbsp;
            <Button variant="success" className="p-1 mb-2 " style={{ width: '50px',fontFamily: 'Times New Roman' }} onClick={alertNoOnClick}>No</Button></center>
        </div>
      </Dialog>
      <Home /><Snacbar open={open} message={message} severity={severity} onClose={handleClose} />
      <div style={{ paddingLeft: "80px" }}>
      <Row>
                    <Col xs={1}><ToggleButton onClick={BackBotton} className='headerstyleStrt' size="small">
                        <ArrowBackIosIcon fontSize="small" style={{ fontSize: '16px', marginLeft: '5px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton></Col>
                    <Col xs={10}></Col>
                    <Col xs={1} style={{textAlign:'end'}}> <ToggleButton onClick={ForwordBotton} className='headerstyleEND' size="small">
                        <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton>
                    </Col>
                </Row>
        <ItemPap>
          <Grid container>
            <Grid xs={4} style={{ marginTop: "1rem" }}>
            <Row>
                <Col xs={1}>
          {/* <ToggleButton onClick={BackBotton} className='headerstyleStrt' size="small"> <ArrowBackIosIcon fontSize="small" style={{ fontSize: '16px',marginLeft:'5px' }} /> </ToggleButton> */}
            </Col>
            <Col xs={11}>
              <Typography style={{ fontFamily: 'Times New Roman'}}  color={"#0b64c5"} fontWeight={"bolder"} variant={"h5"}>
                AccountHead Details Entry
              </Typography><hr></hr>
              </Col>
              </Row>
              <Row className="mt-3">
                <Col xs={5}>
                  <label style={mystyle1}>AccountLedgerType*</label>
                </Col>
                <Col xs={7}>
                  <Form.Select size="sm" type="text" style={mystyle} value={accounts.accountledgerType}
                    onChange={acc_ledgehandlechange} isInvalid={error} id='AcLedgTyp' required>
                    <option value={''}></option>
                    {AccountLedgerType.map((item) => (
                      <option value={item.accountHeadType}>{item.accountHeadType}</option>
                    ))}
                  </Form.Select>
                </Col>
              </Row>
              <Row className="mt-3">
                <Col xs={5}>
                  <label style={mystyle1}>AccountHeadName</label>
                </Col>
                <Col xs={7}>
                  <Form.Control size="sm" type="text" style={mystyle} value={accounts.accountName}
                    onChange={acc_namehandlechange} />
                </Col>
              </Row>
              <Row className="mt-2">
                <Col lg={1}></Col>
                <Col className="mt-3" lg={10}>
                  <Button  style={{ fontFamily: 'Times New Roman'}}variant="success" size="sm" disabled={AcSaveDsa} onClick={AccountSave}>
                    {AcSave ? 'Processing..' : 'Save'}
                  </Button>
                  &nbsp;
                  <Button style={{ fontFamily: 'Times New Roman'}}variant="primary" size="sm" disabled={AcUpdateDsa} onClick={AccountUpdate}>
                    {AcUpdate ? 'Processing..' : 'Update'}
                  </Button>
                  &nbsp;
                  <Button style={{ fontFamily: 'Times New Roman'}}variant="danger" size="sm" disabled={AcDeleteDsa} onClick={AccountDelete}>
                    {AcDelete ? 'Processing..' : 'Delete'}
                  </Button>
                  &nbsp;
                  <Button style={{ fontFamily: 'Times New Roman'}}variant="secondary" size="sm" onClick={refresh}>
                    refresh
                  </Button>
                </Col>
                <Col lg={1}></Col>
              </Row>
            </Grid>

            <Grid xs={8} style={{ marginTop: "1%" }}>
              <ItemPap1>
              <Row>
                  <Col xs={11}>
                <Typography  style={{ fontFamily: 'Times New Roman'}}color={"#0b64c5"} fontWeight={"bolder"} variant={"h5"}>
                  Existing  AccountHead Details
                </Typography>
                </Col>
                <Col xs={1}>
                 {/* <ToggleButton onClick={ForwordBotton} className='headerstyleEND' size="small"> 
                <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px',textAlign:'end'}} /></ToggleButton>  */}
                  </Col>
                </Row>
                <TableContainer sx={{ height: 360 }} style={{ marginTop: "1px" }}>
                  <Table stickyHeader className="table table-bordered">
                    <TableHead>
                      <StyledTableRow>
                        <StyledTableCell style={{ width: "1rem" }}>SlNo</StyledTableCell>
                        <StyledTableCell>AccountHead Name {AccounthdNmSrch()}</StyledTableCell>
                        <StyledTableCell>AccountLedger Type</StyledTableCell>
                        <StyledTableCell style={{ textAlign: 'center' }}>Actions</StyledTableCell>
                      </StyledTableRow>
                    </TableHead>
                    <TableBody>
                    {Filtereddetails.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((item, index) => (
                        <StyledTableRow hover key={item.serialNumber} onClick={() => editAccountHeadDCetails(item)}>
                          <StyledTableCell style={{ width: "1rem",textAlign: 'center' }}>{item.serialNumber}</StyledTableCell>
                          <StyledTableCell style={{textAlign: 'center'}}>{item.accountHeadName}</StyledTableCell>
                          <StyledTableCell style={{textAlign: 'center'}}>{item.accountHeadType}</StyledTableCell>
                          <StyledTableCell style={{textAlign: 'center'}}><lu onClick={() => alertonClickOpen(item)}>{deleteicon()}</lu></StyledTableCell>
                        </StyledTableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  showFirstButton
                  showLastButton
                  component='div'
                  count={Filtereddetails.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onChangeRowsPerpage={handleChangeRowsPerPage}
                />
              </ItemPap1>
            </Grid>
          </Grid>
        </ItemPap>
      </div>
    </div>
  );
}

export default Account;
